import React from 'react'

import styled from '@emotion/styled'
import { mq, grayBorder } from '../../../_style';

const Container = styled.div`
  text-align: right;
  & > * {
    & + * {
      margin-top: 20px;
    }
  }
  & > p {
    font-size: 14px;
    line-height: 1;
    text-align: left;
    font-feature-settings: "palt";
  }
  & > a {
    margin-left: auto;
  }
`

export default class DetailBtns extends React.Component {
  render() {
    return(
      <Container isNoStoreBtns={this.props.isNoStoreBtns}>
        {this.props.children}
      </Container>
    )
  }
}
